export const cities = {
  FR: { city: 'Paris', postalCode: '75000' },
  IT: { city: 'Roma', postalCode: '00100' },
  PT: { city: 'Lisbon', postalCode: '1000-001' },
  ES: { city: 'Madrid', postalCode: '28005' },
  BE: { city: 'Bruxelles', postalCode: '1020' },
  DE: { city: 'Berlin', postalCode: '10115' },
  AT: { city: 'Vienna', postalCode: '1230' },
  NL: { city: 'Amsterdam', postalCode: '1011 AA' },
  UK: { city: 'London', postalCode: 'SW10' },
  PL: { city: 'Warsaw', postalCode: '00-001' },
  CZ: { city: 'Prague', postalCode: '110 00' }
};
